var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiReferAndEarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3a1 1 0 00-1 1v3a1 1 0 001 1h1a.5.5 0 01.354.146L6 9.293l1.146-1.147A.5.5 0 017.5 8h1a1 1 0 001-1V4a1 1 0 00-1-1h-5zm-1.414-.414A2 2 0 013.5 2h5a2 2 0 012 2v3a2 2 0 01-2 2h-.793l-1.353 1.354a.5.5 0 01-.708 0L4.293 9H3.5a2 2 0 01-2-2V4a2 2 0 01.586-1.414zM3.5 4.5A.5.5 0 014 4h4a.5.5 0 010 1H4a.5.5 0 01-.5-.5zm0 2A.5.5 0 014 6h3a.5.5 0 010 1H4a.5.5 0 01-.5-.5z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--refer-and-earn-672d185c0bec71993c7b6ecdfddf4c0d.svg";
export { SvgIconUiReferAndEarn as Component };